import { render, staticRenderFns } from "./Salon.vue?vue&type=template&id=c892289a&scoped=true&"
import script from "./Salon.vue?vue&type=script&lang=js&"
export * from "./Salon.vue?vue&type=script&lang=js&"
import style0 from "./Salon.vue?vue&type=style&index=0&id=c892289a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c892289a",
  null
  
)

export default component.exports